export default __webpack_public_path__ + "static/media/Rectangle 409.be92eef1.png";